import { Button } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ChartRuleResolveError, CustomChartType } from '@/entities/dashboards';
import { CHART_TYPE_LABEL_KEY } from './chartCatalog';

type Props = {
  error: ChartRuleResolveError;
  /** Выбор типа, которому правило отвечает: типы предлагает сам отказ */
  onSelectType: (type: CustomChartType) => void;
};

/**
 * Отказ истолкования или заверения правила: причина и типы диаграмм, которым выборка отвечает.
 *
 * Предложенные типы показаны кнопками: несоответствие типа закрывается выбором подходящего, а
 * не повторным описанием — правило уже составлено и остаётся прежним.
 */
export const ChartRuleErrorNotice: FC<Props> = ({ error, onSelectType }) => {
  const { t } = useTranslation(['qualityDashboard']);
  const suggestedTypes = error.suggestedChartTypes ?? [];

  return (
    <div className="flex flex-col gap-2 rounded-md border border-destructive p-2">
      <p className="text-sm text-destructive">{error.message || t('qualityDashboard:presets.editor.resolveFailed')}</p>
      {suggestedTypes.length > 0 && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-muted-foreground">{t('qualityDashboard:presets.editor.suggestedTypes')}</span>
          {suggestedTypes.map((type) => (
            <Button key={type} variant="secondary" size="sm" onClick={() => onSelectType(type)}>
              {t(CHART_TYPE_LABEL_KEY[type])}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
